import { z } from 'zod';

import { latLngSchema, latitudeSchema, longitudeSchema } from './primitives';

export const addressInputSchema = z.object({
  line1: z.string().min(1),
  line2: z.string().optional(),
  city: z.string().min(1),
  postalCode: z.string().optional(),
  country: z.string().min(2).max(2).describe('ISO 3166-1 alpha-2'),
});
export type AddressInput = z.infer<typeof addressInputSchema>;

export const addressSchema = addressInputSchema.extend({
  latitude: latitudeSchema,
  longitude: longitudeSchema,
});
export type Address = z.infer<typeof addressSchema>;

export const normalizedAddressSchema = addressSchema.extend({
  formatted: z.string(),
});
export type NormalizedAddress = z.infer<typeof normalizedAddressSchema>;

export const geocodeResultSchema = z.object({
  address: normalizedAddressSchema,
  coordinates: latLngSchema,
  confidence: z.number().min(0).max(1).optional(),
});
export type GeocodeResult = z.infer<typeof geocodeResultSchema>;
